var exports = {
  "x": "ExpiryFootnote.module__footnote___NXBWVk",
  "m": "ExpiryFootnote.module__inlineFootnote___NXBWVk",
};

module.exports = exports;
